import { render, staticRenderFns } from "./FooterPc.vue?vue&type=template&id=51bee9d5&"
import script from "./FooterPc.vue?vue&type=script&lang=js&"
export * from "./FooterPc.vue?vue&type=script&lang=js&"
import style0 from "./FooterPc.vue?vue&type=style&index=0&id=51bee9d5&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports